export const ELEMENTS = {
    "terre": {
        "color": "#aad681",
        "name": "earth",
    },
    "eau": {
        "color": "#7ae0d9",
        "name": "water"
    },
    "feu": {
        "color": "#e37470",
        "name": "fire"
    },
    "air": {
        "color": "#fae087",
        "name": "air"
    }
};